<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <!-- selection="multiple" -->
          <c-table
            ref="table"
            title="검진결과 목록"
            tableId="table"
            :columns="grid.columns"
            :gridHeight="grid.height"
            :merge="grid.merge"
            :data="grid.data"
            :filtering="true"
            :columnSetting="false"
            :usePaging="true"
            :isExcelDown="false"
            :isFullScreen="false"
            :expandAll="true"
            rowKey="heaCheckupResultId"
            @linkClick="linkClick"
          >
            <!-- 버튼 영역 -->
            <template slot="table-button">
              <q-btn-group outline >
                <c-btn v-if="editable" label="결과 엑셀업로드" icon="upload"  @btnClicked="openExcelUploader"/>
                <!-- <c-btn
                  v-if="editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="grid.data"
                  :mappingType="mappingType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" /> -->
                <!-- <c-btn v-if="editable && grid.data.length > 0" :showLoading="false"  label="삭제" icon="remove" @btnClicked="removeData" /> -->
              </q-btn-group>
            </template>
            <template slot="table-chip">
              <font color="#C10015">
                ※ 추가로 엑셀업로드 시 기존데이터에 결과가 추가됩니다(중복 허용).
              </font>
            </template>
          </c-table>
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'check-up-result',
  props: {
    data: {
      type: Object,
      default: () => ({
        heaCheckupPlanId: '',
      }),
    },
    count: {
      type: Number,
      default: 0,
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: false,
      grid: {
        merge: [
          { index: 0, colName: 'mergeGroup' },
          { index: 1, colName: 'mergeGroup' },
          { index: 2, colName: 'mergeGroup' },
          { index: 3, colName: 'mergeGroup' },
        ],
        columns: [
          {
            name: 'deptName',
            field: 'deptName',
            label: '부서',
            align: 'center',
            style: 'width: 100px',
            sortable: false,
          },
          {
            name: 'checkTypeName',
            field: 'checkTypeName',
            label: '검진구분',
            align: 'center',
            style: 'width: 100px',
            sortable: false,
          },
          {
            name: 'userName',
            field: 'userName',
            label: '대상자명',
            align: 'center',
            style: 'width: 100px',
            sortable: false,
            type: 'link'
          },
          {
            name: 'checkupDate',
            field: 'checkupDate',
            label: '검진일',
            align: 'center',
            style: 'width: 100px',
            sortable: false,
          },
          {
            name: 'judgmentName',
            field: 'judgmentName',
            label: '판정',
            align: 'center',
            style: 'width: 50px',
            sortable: false,
          },
          {
            name: 'diseaseName',
            field: 'diseaseName',
            label: '질환',
            align: 'center',
            style: 'width: 120px',
            sortable: false,
          },
          {
            name: 'hazardNames',
            field: 'hazardNames',
            label: '관련유해인자',
            align: 'left',
            style: 'width: 450px',
            sortable: false,
          },
        ],
        data: [],
        height: '800px',
      },
      tabItems: [
        // person_search
        // { name: 'opinion', icon: 'sick', label: '소견결과', component: () => import(`${'./checkupOpinion.vue'}`) },
        { name: 'disease', icon: 'sick', label: '판정결과', component: () => import(`${'./checkupDisease.vue'}`) },
        { name: 'examine', icon: 'content_paste', label: '검진항목', component: () => import(`${'./checkupExamine.vue'}`) },
      ],
      excelReturn: {
        results: [],
        columns: [],
      },
      examines: [],
      mappingType: 'POST',
      listUrl: '',
      examineListUrl: '',
      isSave: false, 
      saveUrl: '',
      deleteUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 300) + 'px';
    },
  },
  watch: {
    'count'() {
      this.getDetail();
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.hea.checkup.result.list.url;
      this.examineListUrl = selectConfig.hea.examine.list.url;
      this.saveUrl = transactionConfig.hea.checkup.results.save.url;
      this.deleteUrl = transactionConfig.hea.checkup.results.delete.url;
      // code setting
      // list setting
      this.getDetail();
      this.getExamines();
    },
    getDetail() {
      if (this.data.heaCheckupPlanId) {
        this.$http.url = this.$format(this.listUrl, this.data.heaCheckupPlanId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid.data = _result.data;
        },);
      } 
    },
    getExamines() {
      this.$http.url = this.examineListUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        useFlag: 'Y'
      };
      this.$http.request((_result) => {
        this.examines = _result.data;
      },);
    },
    linkClick(result) {
      this.popupOptions.target = () => import(`${"./checkUpResultDetail.vue"}`);
      this.popupOptions.title = result.userName + '의 건강검진 결과 상세';
      this.popupOptions.width = '70%';
      this.popupOptions.isFull = true;
      this.popupOptions.param = {
        heaCheckupResultId: result ? result.heaCheckupResultId : '',
        checkTypeName: result ? result.checkTypeName : '',
        checkupDate: result ? result.checkupDate : '',
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getDetail();
    },
    saveData() {
      // let isConti = true;
      // if (this.grid.data.length === 0) {
      //   window.getApp.$emit('ALERT', {
      //     title: '안내', // 안내
      //     message: '대상자를 추가하세요.', // 대상자를 추가하세요.
      //     type: 'warning', // success / info / warning / error
      //   });
      //   isConti = false;
      //   return;
      // }
      // let checkItem = ['checkupDate',]
      // this.$_.forEach(this.grid.data, item => {
      //   this.$_.forEach(checkItem, check => {
      //     if (!item[check]) {
      //       isConti = false;
      //       return false;
      //     }
      //   })
      // });
      // if (!isConti) {
      //   window.getApp.$emit('ALERT', {
      //     title: '안내', // 안내
      //     message: '필수 입력값을 입력해 주세요. [검진일]',
      //     type: 'warning', // success / info / warning / error
      //   });
      // } else {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.isSave = !this.isSave;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      // }
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    removeData() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl;
          this.$http.type = 'DELETE';
          this.$http.param = {
            data: Object.values(selectData)
          }
          this.$http.request(() => {
            this.$_.forEach(selectData, item => {
              this.grid.data = this.$_.reject(this.grid.data, { heaCheckupResultId: item.heaCheckupResultId })
          })
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('getDetail')
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      }
    },
    openExcelUploader() {
      this.popupOptions.title = '건강검진결과 업로드'; // 건강검진결과 업로드
      this.popupOptions.param = {
        plantCd: this.data.plantCd,
        examines: this.examines
      }
      this.popupOptions.target = () => import(`${'./checkUpResultExcelUpload.vue'}`);
      this.popupOptions.isFull = true;
      this.popupOptions.width = '90%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeExcelUploadPopup;
    },
    closeExcelUploadPopup(_result, columns) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (_result && _result.length > 0) {
        this.$set(this.excelReturn, 'results', _result);
        this.$set(this.excelReturn, 'columns', columns);
        let promises = [
          {
            func: this.saveCheckupResult,
          },
          {
            func: this.checkupCycleUpdate,
          },
        ];
        this.$comm.orderedPromise(promises);
      }
    },
    saveCheckupResult() {
      return new Promise((resolve, _reject) => { 
        let s_data = this.$_.filter(this.excelReturn.results, (item) => { return !item.error_message })
        this.$_.forEach(s_data, item => {
          item.heaCheckupPlanId = this.data.heaCheckupPlanId
          item.heaCheckupResultId = uid();  // 일련번호
          item.regUserId = this.$store.getters.user.userId;  // 등록자 ID
          item.chgUserId = this.$store.getters.user.userId;  // 수정자 ID
          item.editFlag = 'C';
          item.columnList = this.excelReturn.columns
          item.hazardNames = this.$_.split(item.hazardNames, '/');
          item.judgmentNames = this.$_.split(item.judgmentNames, '/');
          item.diseaseNames = this.$_.split(item.diseaseNames, '/');
          item.specialMeasures = this.$_.split(item.specialMeasures, '/');
          item.specialSuitabilities = this.$_.split(item.specialSuitabilities, '/');
          item.remarks = this.$_.split(item.remarks, '/');
          if (this.examines && this.examines.length > 0) {
            item.examines = JSON.stringify(this.$_.map(this.examines, (examine) => {
              return {
                key: examine.examineId,
                keyname: examine.examineName,
                value: item[examine.examineId],
              }
            }))
          }
        })
        this.$http.url = transactionConfig.hea.checkup.results.uploadSave.url;
        this.$http.type = 'POST';
        this.$http.param = s_data;
        this.$http.request(() => {
          resolve(true);
        }, () => {
          _reject("");
        });
      });
    },
    checkupCycleUpdate() {
      return new Promise((resolve, _reject) => {
        let users = this.$_.filter(this.excelReturn.results, (item) => { return !item.error_message })
        users = this.$_.map(users, (item) => {
          return {
            empNo: item.empNo,
            checkupDate: item.checkupDate,
            checkTypeName: item.checkTypeName,
            checkupCycleCd: (this.$_.trim(item.checkTypeName) === '배치전' ? 'CUC0000001' : 'CUC0000002'), // 배치전이면 6개월 그 외에는 1년
            editFlag: 'U',
            chgUserId: this.$store.getters.user.userId,
          }
        })
        if (users && users.length > 0) {
          users = this.$_.uniqBy(this.$_.orderBy(users, ['empNo', 'checkupDate'], ['asc', 'desc']), 'empNo')
        }
        this.$http.url = transactionConfig.mdm.user.cycle.url;
        this.$http.type = 'POST';
        this.$http.param = users;
        this.$http.request(() => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          this.getDetail();
          this.$emit('getDetail')
          resolve(true);
        }, () => {
          _reject("");
        });
      });
    },
  }
};
</script>